document.addEventListener('DOMContentLoaded', function () {
    const codeInput = document.getElementById('otpCode');
    if (codeInput) {
        // L'auto-submit à 6 chiffres suivi d'un clic sur « Valider » (ou d'un autofill qui
        // rejoue `input`) envoyait deux POST : le second échoue, le flux étant déjà consommé.
        let submitted = false;

        codeInput.form.addEventListener('submit', function (event) {
            if (submitted) {
                event.preventDefault();
                return;
            }
            submitted = true;
            // readOnly et non disabled : un champ désactivé serait exclu des données envoyées.
            codeInput.readOnly = true;
            this.querySelector('button[type="submit"]').disabled = true;
        });

        codeInput.addEventListener('input', function () {
            this.value = this.value.replace(/\D/g, '').slice(0, 6);
            if (this.value.length === 6 && !submitted) {
                this.form.requestSubmit();
            }
        });
    }

    const countdown = document.getElementById('otpCountdown');
    if (countdown) {
        const expiresAt = parseInt(countdown.dataset.expiresAt, 10);
        const labelExpiresIn = countdown.dataset.labelExpiresIn;
        const labelExpired = countdown.dataset.labelExpired;

        const tick = function () {
            const remaining = expiresAt - Math.floor(Date.now() / 1000);
            if (remaining <= 0) {
                countdown.textContent = labelExpired;
                if (codeInput) {
                    codeInput.disabled = true;
                }
                clearInterval(interval);
                return;
            }
            const minutes = Math.floor(remaining / 60);
            const seconds = remaining % 60;
            const formatted = minutes + ':' + String(seconds).padStart(2, '0');
            countdown.textContent = labelExpiresIn.replace('%time%', formatted);
        };

        const interval = setInterval(tick, 1000);
        tick();
    }

    const resendButton = document.getElementById('otpResend');
    if (resendButton) {
        const resendAt = parseInt(resendButton.dataset.resendAt, 10);
        const labelResend = resendButton.dataset.labelResend;
        const labelResendIn = resendButton.dataset.labelResendIn;

        const tick = function () {
            const remaining = resendAt - Math.floor(Date.now() / 1000);
            if (remaining <= 0) {
                resendButton.textContent = labelResend;
                resendButton.disabled = false;
                clearInterval(interval);
                return;
            }
            resendButton.disabled = true;
            resendButton.textContent = labelResendIn.replace('%seconds%', String(remaining));
        };

        const interval = setInterval(tick, 1000);
        tick();
    }
});
